import React, { useState } from 'react'

// Components
import Bills from '../Bills/Bills'
import Expenses from '../Expenses/Expenses'
import Payday from '../Payday/Payday'
import Savings from '../Savings/Savings'

const AccountOverview = props => {
  const [username] = useState(props.user.username)
  const [bills] = useState(props.user.bills)
  const [expenses] = useState(props.user.expenses)

  const newPayday = newPayday => {
    props.handleUpdatedPayday(newPayday)
  }

  const newSavings = newSavings => {
    props.handleUpdatedSavings(newSavings)
  }

  return (
    <div className='account-grid-container'>
      <Payday
        payday={props.user.payday}
        newPayday={newPayday}
      />
      <Bills
        bills={bills}
        username={username}
        onHandleViewBills={props.handleViewBills}
      />
      <Expenses
        expenses={expenses}
        username={username}
        onHandleViewExpenses={props.handleViewExpenses}
      />
      <Savings
        savings={props.user.savings}
        newSavings={newSavings}
      />
    </div>
  )
}

export default AccountOverview
